module.exports = __webpack_public_path__ + "static/media/kolorowanka_2.a43d5de2.png";